import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../env';
import { getLocalStorage } from '../utils/function/localStorage';

export const feedbackApi = createApi({
  reducerPath: 'feedbackApi',

  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    prepareHeaders: (headers) => {
      const token = getLocalStorage('tp_Aa_uth_access');
      if (token) {
        headers.set('X-Auth-Token', token);
      }
      return headers;
    },
  }),

  tagTypes: ['Feedbacks', 'Tags'],

  endpoints: (builder) => ({
    submitFeedback: builder.mutation({
      query: (feedbackData) => ({
        url: '/secure/feedback',
        method: 'POST',
        body: feedbackData,
      }),
      invalidatesTags: ['Feedbacks'], 
    }),

    getTags: builder.query({
      query: () => '/secure/tags',
      providesTags: ['Tags'],
    }),
  }),
});

export const {
  useSubmitFeedbackMutation,
  useGetTagsQuery,
} = feedbackApi;